
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../base/Button';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetStarted = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header 
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://static.readdy.ai/image/0bc1a2c5b0dc90360880a6e9e7b2e34d/47ac74eed8c1fdd28ac65b9dbac25b53.png" 
            alt="AiCH Logo" 
            className="h-10 w-auto"
          />
        </div>
        <nav className="hidden lg:flex items-center space-x-8">
          <a 
            href="#solutions" 
            className={`hover:text-emerald-600 transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {t('header.solutions')}
          </a>
          <a 
            href="#about" 
            className={`hover:text-emerald-600 transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {t('header.about')}
          </a>
          <a 
            href="#testimonials" 
            className={`hover:text-emerald-600 transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {t('header.testimonials')}
          </a>
          <a 
            href="#contact" 
            className={`hover:text-emerald-600 transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {t('header.contact')}
          </a>
        </nav>
        <div className="flex items-center space-x-4">
          <LanguageSwitcher isScrolled={isScrolled} />
          <Button 
            variant="primary" 
            size="md"
            onClick={handleGetStarted}
          >
            {t('header.getStarted')}
          </Button>
        </div>
      </div>
    </header>
  );
}
